module.exports = __webpack_public_path__ + "img/skill_icon.3207f2ac.svg";